<template>
  <!-- Legacy shim: was a FontAwesome `<i class>` wrapper. Now renders a Cygnus
       glyph — the `class`/`icon` prop is resolved via CygnusIcon's own
       FA-name resolver (manifest + alias table). Kept for backward compat;
       new code should use <CygnusIcon> directly. -->
  <CygnusIcon :name="props.icon || props.class" :style="colour ? { color: colour } : null" />
</template>

<script setup>
const props = defineProps(
    {
      class: {
        type: String,
        required: false,
        default: '',
      },
      icon: {
        type: String,
        required: false,
        default: '',
      },
      colour: {
        type: String,
        required: false
      }
    }
)
</script>
